/**
 * @deprecated This file is deprecated. Use @starjack/utils instead.
 */

import { DATE_FORMAT_BACKEND_STRING } from '@/constants';
import { format, getDate, getMonth, getYear, isDate, isValid } from 'date-fns';
import { StarjackDate } from '@/models/general';

/**
 * @deprecated Use formatStarjackDate from @starjack/utils instead.
 */
export const formatStarjackDate = (date: Date) => {
    if (isValid(date)) {
        return format(date, 'dd.MM.yyyy');
    }

    return null;
};

/**
 * @deprecated Use formatDateWithTime from @starjack/utils instead.
 */
export const formatStarjackDateWithTime = (date: Date) => {
    if (isValid(date)) {
        return format(date, 'dd.MM.yyyy HH:mm');
    }

    return null;
};

/**
 * @deprecated Use formatStarjackDateToBackendString from @starjack/utils instead.
 */
export const formatStarjackDateToBackendString = (
    date: StarjackDate
): string => {
    if (!date) return null;
    return format(date, DATE_FORMAT_BACKEND_STRING);
};

/**
 * @deprecated Use convertDateFromDateArray from @starjack/utils instead.
 */
export const convertDateFromDateArray = (dateArray: number[]) => {
    if (!Array.isArray(dateArray)) {
        return null;
    }

    const [year, month, day, hours = 0, minutes = 0] = dateArray;
    const timeZoneOffsetHours = new Date().getTimezoneOffset() / 60;

    if (hours === 0 && minutes === 0) {
        return new Date(year, month - 1, day);
    } else {
        return new Date(
            year,
            month - 1,
            day,
            hours - timeZoneOffsetHours,
            minutes
        );
    }
};

/**
 * @deprecated Use convertDateArrayFromDate from @starjack/utils instead.
 */
export const convertDateArrayFromDate = (date: Date) => {
    if (!isDate(date)) return [];

    return [getYear(date), getMonth(date) + 1, getDate(date)];
};

/**
 * @deprecated Use isOfTypeDate from @/utils/guards instead.
 */
export const isOfTypeDate = (value: unknown): value is Date => {
    return isDate(value);
};
